import { useState, useCallback } from 'react';
import quarkusApi from '../../api/quarkusApi';

export function useSaveReferral() {
  const [isSaving, setSaving] = useState(false);

  const save = useCallback((referral) => {
    setSaving(true);
    return quarkusApi
      .post('/leads-by-clinic', referral, {
        headers: { Authorization: sessionStorage.getItem('token') },
      })
      .finally(() => setSaving(false));
  }, []);

  return { save, isSaving };
}
